import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { activityService } from '../../services/activityService';

export const useGetPortfolioMovementsList = params => {
  return useQuery({
    enabled: !!params?.type,
    staleTime: 1000 * 60, // 1 minute stale
    queryKey: [QUERY_KEYS.activity.portfolio_movements, params],
    queryFn: () =>
      activityService.portfolioMovements({ limit: 10, ...params }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
